import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result } from '@digibricks/core';
import { AnswerReport } from './answer-report';
export var FillInBlankAnswerReport = /*#__PURE__*/function (_AnswerReport) {
  _inherits(FillInBlankAnswerReport, _AnswerReport);

  var _super = _createSuper(FillInBlankAnswerReport);

  function FillInBlankAnswerReport() {
    _classCallCheck(this, FillInBlankAnswerReport);

    return _super.apply(this, arguments);
  }

  _createClass(FillInBlankAnswerReport, [{
    key: "correctAnswerPercentage",
    get: function get() {
      return this.props.correctAnswerPercentage;
    }
  }, {
    key: "totalCorrectAnswers",
    get: function get() {
      return this.props.totalCorrectAnswers;
    }
  }, {
    key: "wrongAnswerPercentage",
    get: function get() {
      return this.props.wrongAnswerPercentage;
    }
  }, {
    key: "totalWrongAnswers",
    get: function get() {
      return this.props.totalWrongAnswers;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollection = [{
        argument: props.correctAnswerPercentage,
        argumentName: 'Correct Answer Percentage'
      }, {
        argument: props.totalCorrectAnswers,
        argumentName: 'Total Correct Answers'
      }, {
        argument: props.wrongAnswerPercentage,
        argumentName: 'Wrong Answer Percentage'
      }, {
        argument: props.totalWrongAnswers,
        argumentName: 'Total Wrong Answers'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new FillInBlankAnswerReport(props));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var correctAnswerPercentage = data.correctAnswerPercentage,
            totalCorrectAnswers = data.totalCorrectAnswers,
            wrongAnswerPercentage = data.wrongAnswerPercentage,
            totalWrongAnswers = data.totalWrongAnswers;

        var basePropsOrError = _get(_getPrototypeOf(FillInBlankAnswerReport), "createBaseProps", this).call(this, data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var baseProps = basePropsOrError.getValue();
        var fillInBlankAnswerReportOrError = this.create(_objectSpread(_objectSpread({}, baseProps), {}, {
          totalCorrectAnswers: totalCorrectAnswers,
          correctAnswerPercentage: correctAnswerPercentage,
          wrongAnswerPercentage: wrongAnswerPercentage,
          totalWrongAnswers: totalWrongAnswers
        }));

        if (fillInBlankAnswerReportOrError.isFailure) {
          return Result.fail(fillInBlankAnswerReportOrError.error);
        }

        var fillInBlankAnswerReport = fillInBlankAnswerReportOrError.getValue();
        return Result.ok(fillInBlankAnswerReport);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return FillInBlankAnswerReport;
}(AnswerReport);